import React from 'react';
import PropTypes from 'prop-types';
import Heading, { H3 } from 'components/atoms/Heading';
import Section from './Section';

import Icon from 'components/atoms/Icon';
import { checkmark } from 'components/atoms/Icon/icons';
import * as styles from './Product.scss';
const FacilityList = ({ list }) => (
  <Section className={styles.facilities}>
    {list.map(facilityGroup => (
      <React.Fragment key={facilityGroup.name}>
        <H3
          alt
          size={Heading.sizes.heading3}
          className={styles.sectionSubTitle}
          gutterBottom
        >
          {facilityGroup.name}
        </H3>
        <ul className={styles.facilityList}>
          {facilityGroup.subFacilities.map(facility => (
            <li key={facility.name}>
              <Icon
                icon={checkmark}
                size={['0.9em', '0.9em']}
                role="presentation"
              />
              {facility.name}
              {!!facility.notes && `: ${facility.notes}`}
            </li>
          ))}
        </ul>
      </React.Fragment>
    ))}
  </Section>
);
FacilityList.propTypes = {
  list: PropTypes.any,
};

export default FacilityList;
